import './App.css';
import './projectCard.css';
import Header from "./components/Header";
import Home from "./components/Home";
import Skills from "./components/Skills";
import Project from './components/Project';
import Profile from './components/Profile';
import Testimonial from './components/Testimonial';
import Experience from './components/Experience';
import Footer from './components/Footer';
import BallSaperator from './components/BallSaperator';
import FloatingBubbles from './components/FloatingBubbles';
import Youtube from './components/Youtube';
import Ai from './components/ai';
import Gallery from './components/Gallery';
import FeaturedSection from './components/FeaturedSection';
// import Gallery from './components/Gallery';
function App() {
  return (
    <>
      <div>
        <Header />
        <Home />
        {/* <BallSaperator /> */}
        <FloatingBubbles />
      </div>
      <div className='about-section'>
        
        <Profile />
        <Ai />
        <FeaturedSection />
        <Skills />
      </div>
      <div>
        <Gallery />
      </div>
      <div>
        <Youtube />
        <BallSaperator />
        <Project />
      </div>
      <div>
        <Testimonial />
      </div>

      <div>
        <Experience />
      </div>
      <div>
        {/* <Counter/> */}
      </div>

      <div>
        <Footer />
      </div>
    </>
  );
}

export default App;
